const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-copy ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    value: { type: String, default: '' },
    label: String,
    multiline: Boolean,
  }

  init() {
    this.state.copied = false
  }

  async copyValue() {
    try {
      await navigator.clipboard.writeText(this.props.value)
      this.state.copied = true
      this.setTimeout(() => (this.state.copied = false), 1600)
    } catch {
      window.Toast?.error('Copy failed; select the text and copy it by hand')
    }
  }

  CSS = `:fez {
display:block;.copy-label{display:block;margin-bottom:6px;font-size:var(--text-sm);font-weight:var(--weight-semibold)}.box{display:flex;align-items:flex-start;gap:var(--space-2);padding:var(--space-2) var(--space-2) var(--space-2) var(--space-3);border:1px solid var(--color-border);border-radius:var(--radius-md);background:var(--color-code-bg)}code{flex:1;min-width:0;padding-top:5px;color:var(--color-text);font-size:var(--text-sm);line-height:1.5;overflow-wrap:anywhere;user-select:all}.multi code{white-space:pre-wrap}.single code{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;user-select:all}
}`

  HTML = `<div>
{#if props.label}
<span class="copy-label">{props.label}</span>
{/if}
<div class="box" class:single={!props.multiline} class:multi={props.multiline}>
<code>{props.value}</code>
<ui-button size="sm" variant={state.copied ? 'secondary' : 'primary'} icon={state.copied ? 'check' : 'copy'} label={state.copied ? 'Copied' : 'Copy'} onclick="fez.copyValue()"></ui-button>
</div>
</div>`
};
}

Fez('ui-copy', __fez_component_0);

export default __fez_component_0;
